const initExpertSliders = () => {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('[data-expert-slider]').forEach((slider) => {
    if (slider.dataset.swiperInitialized === 'true') return;

    const section = slider.closest('.expert-slider');
    const navBar = section ? section.querySelector('.expert-slider__nav-bar') : null;
    const nextEl = navBar ? navBar.querySelector('.expert-slider__arrow--next') : null;
    const prevEl = navBar ? navBar.querySelector('.expert-slider__arrow--prev') : null;

    const options = JSON.parse(slider.getAttribute('data-expert-options') || '{}');

    const slidesPerViewDesktop = Number(options.slidesPerViewDesktop || 3);
    const slidesPerViewMobile = Number(options.slidesPerViewMobile || 1);
    const gap = Number(options.gap || 16);

    function updateNavWidth() {
      if (!navBar) return;
      const slide = slider.querySelector('.swiper-slide');
      if (slide) {
        navBar.style.width = slide.offsetWidth + 'px';
      }
    }

    function updateSlideCounter(swiperInstance) {
      if (!navBar) return;
      const counterEl = navBar.querySelector('.expert-slider__counter');
      if (!counterEl) return;

      const totalSlides = swiperInstance.slides.length;
      const spv =
        typeof swiperInstance.params.slidesPerView === 'number'
          ? swiperInstance.params.slidesPerView
          : 1;

      const totalSwipes = Math.max(1, totalSlides - spv + 1);
      const currentSwipe = Math.min(totalSwipes, (swiperInstance.realIndex || 0) + 1);

      counterEl.textContent = currentSwipe + '/' + totalSwipes;
    }

    /* eslint-disable no-new */
    new Swiper(slider, {
      slidesPerView: slidesPerViewDesktop,
      spaceBetween: gap,
      loop: false,
      watchOverflow: true,
      breakpoints: {
        1: {
          slidesPerView: slidesPerViewMobile,
          spaceBetween: gap
        },
        768: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: gap
        },
        1800: {
          slidesPerView: slidesPerViewDesktop + 1,
          spaceBetween: gap
        }
      },
      navigation:
        nextEl && prevEl
          ? { nextEl, prevEl }
          : false,
      on: {
        init(swiper) {
          updateNavWidth();
          updateSlideCounter(swiper);
        },
        slideChange(swiper) {
          updateSlideCounter(swiper);
        },
        resize(swiper) {
          updateNavWidth();
          updateSlideCounter(swiper);
        }
      }
    });
    /* eslint-enable no-new */
    slider.dataset.swiperInitialized = 'true';
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initExpertSliders);
} else {
  initExpertSliders();
}

document.addEventListener('shopify:section:load', initExpertSliders);
